import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromAccountInfo from './reducers';
import { EffectsModule } from '@ngrx/effects';
import { AccountInfoEffects } from './effects/account-info.effects';
import { UpdateTweModalEffects } from './effects/update-twe-modal.effects';
import { AccountInfoComponent } from './containers/account-info.component';
import { CashBalanceComponent } from './components/cash-balance/cash-balance.component';
import { CashBalanceListComponent } from './components/cash-balance-list/cash-balance-list.component';
import { PalBalanceComponent } from './components/pal-balance/pal-balance.component';
import { PalBalanceListComponent } from './components/pal-balance-list/pal-balance-list.component';
import { TaxWitholdingComponent } from './components/tax-withholding/tax-withholding.component';
import { EauthComponent } from './components/eAuth/eauth.component';
import { AccountInfoHeaderComponent } from './components/account-info-header/account-info-header.component';
import { AccountActionsComponent } from './components/account-actions/account-actions.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { RmdAgeDateComponent } from './components/rmd-age-date/rmd-age-date.component';
import { CoreService, TabHeaderModule } from '@charlesschwab/sac-ui-core';
import { ContextService } from 'projects/integration/src/app/context.service';
import { windowProvider, WindowToken } from '@charlesschwab/as-ui-core';

const COMPONENTS = [
  CashBalanceListComponent,
  CashBalanceComponent,
  PalBalanceListComponent,
  PalBalanceComponent,
  AccountInfoHeaderComponent,
  AccountActionsComponent,
  TaxWitholdingComponent,
  EauthComponent,
  RmdAgeDateComponent
];

const CONTAINERS = [
  AccountInfoComponent,
]

@NgModule({
declarations: [COMPONENTS, CONTAINERS],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    TabHeaderModule,
    StoreModule.forFeature(
      fromAccountInfo.accountInfoFeatureKey,
      fromAccountInfo.reducers
    ),
    EffectsModule.forFeature([AccountInfoEffects, UpdateTweModalEffects]),
  ],
  providers: [
    ContextService,
    CoreService,
    { provide: WindowToken, useFactory: windowProvider },
  ],

  exports: [
    AccountInfoComponent,
    AccountInfoHeaderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AccountInfoModule { }
